import { GetBrokerResponse } from 'api/broker';
import { ReferentialKey } from 'api/referential';
import { CourtierListItem } from 'api/courtiers';
import { normalizeCountryCode } from 'features/new-actor/mappers/optim/normalizeCountryCode';
import { brokersAPI } from 'services/swagger-api';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { BrokerFormFieldNames } from '../form/BrokerFormFieldNames';
import { BrokerFormValues } from '../form/BrokerFormValues';

/**
 * Prefill of the broker edit form from the dedicated read (GET courtiers/{id}), shaped like
 * the update command. If the read fails, the list row still prefills what it knows and the
 * admin fills the rest.
 */
export async function loadBrokerEditValues(
  row: CourtierListItem,
  referentialsData: any
): Promise<Partial<BrokerFormValues>> {
  let broker: GetBrokerResponse | undefined;
  try {
    broker = await brokersAPI.getBroker({ courtierId: row.id });
  } catch (error) {
    console.error(error);
  }

  const address = broker?.address;
  // The form holds plateforme codes; the read returns the reference account's plateforme ids.
  const plateformeRefs: Array<{ id: string; code: string }> = referentialsData?.[ReferentialKey.Plateforme] ?? [];
  const plateformeCodes = (broker?.plateformeIds ?? []).flatMap((plateformeId) => {
    const ref = plateformeRefs.find((item) => item.id === plateformeId);
    return ref ? [ref.code] : [];
  });

  return {
    [BrokerFormFieldNames.CompanyName]: broker?.companyName || row.name || '',
    [BrokerFormFieldNames.Phone]: broker?.phone || row.phone || '',
    [BrokerFormFieldNames.ComplaintEmail]: broker?.complaintEmail || '',
    [BrokerFormFieldNames.RegistrationNumber]: broker?.registrationNumber || row.siret || '',
    [BrokerFormFieldNames.Capital]: broker?.capital ?? 0,
    [BrokerFormFieldNames.RcsCity]: broker?.rcsCity || '',
    [BrokerFormFieldNames.RcsNumber]: broker?.rcsNumber || '',
    [BrokerFormFieldNames.OriasNumber]: broker?.oriasNumber || row.orias || '',
    [BrokerFormFieldNames.Rcp]: broker?.rcp || '',
    [AddressFormFieldNames.Address]: address?.line1 || '',
    [AddressFormFieldNames.AdditionalAddress]: address?.line2 || '',
    [AddressFormFieldNames.PostalCode]: address?.zipCode || '',
    [AddressFormFieldNames.City]: address?.city || '',
    [AddressFormFieldNames.Country]: normalizeCountryCode(address?.country, referentialsData) || 'FR',
    [BrokerFormFieldNames.FirstName]: broker?.firstName || '',
    [BrokerFormFieldNames.LastName]: broker?.lastName || '',
    [BrokerFormFieldNames.Email]: broker?.email || row.email || '',
    [BrokerFormFieldNames.Username]: broker?.username || '',
    [BrokerFormFieldNames.PlateformeIds]: plateformeCodes,
  };
}
